import React, { useState } from 'react';
import { Container, Col, Row, Form } from 'react-bootstrap';
import Header from '../Header';
import Footer from '../Footer';
import { Link, useParams } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import { School } from '../../Services/School';
import ActionButton from '../ActionButton';
import { staticData } from '../../helpers/data';
import { sanitize, validateFormFields } from '../../utils/validationUtils';

const formatDate = () => {
  const d = new Date();
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const day = d.getDate().toString().padStart(2, '0');
  const year = d.getFullYear();
  return [month, day, year].join('/');
};

function ParSignupStepThree({ nextStep, prevStep, handleFormData, handleSchool, values }) {
  const [error2, setError2] = useState({});
  const { id } = useParams();

  const validateForm = () => {
    const sanitizedData = {
      ...Object.keys(values).reduce((acc, key) => {
        acc[key] = sanitize(values[key]);
        return acc;
      }, {})
    };

    const errors = validateFormFields(sanitizedData, 'parent');
    setError2(errors);

    return Object.keys(errors).length === 0;
  };

  const submitFormData = (e) => {
    e.preventDefault();
    if (validateForm()) {
      nextStep();
    }
  };

  const handleOnChange = (e) => {
    const { name, checked } = e.target;
    handleSchool(name, checked);
  };

  return (
    <>
      <Header />
      <section className="login-body" style={{ backgroundImage: 'url(\"images/signup-bg.jpg\")' }}>
        <Container>
          <Row>
            <Col md={12}>
              <div className="step-progress">
                <div className="step-progress-bar">
                  <div className="step-progress-percent" style={{ width: '75%' }}></div>
                </div>
                <div className="step-progress-text">
                  <h6>Parental Consent</h6>
                  <h6>75% Completed</h6>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={9}>
              <div className="signup-box">
                <div className="signup-left">
                  <h4>{staticData?.verbiage?.parent[3]?.heading}</h4>
                  <p>{staticData?.verbiage?.parent[3]?.text}</p>
                  <div className="signup-step" style={{ marginTop: 260 }}>
                    <ul><li></li><li></li><li className="active"></li><li></li></ul>
                  </div>
                </div>
                <div className="signup-right">
                  <Form onSubmit={submitFormData}>
                    <div className="add-details">
                      <Row>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" name="first_name" onChange={handleFormData("first_name")} defaultValue={values.first_name} placeholder="First Name*" />
                            <span className="err">{error2?.first_name}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" name="last_name" onChange={handleFormData("last_name")} defaultValue={values.last_name} placeholder="Last Name*" />
                            <span className="err">{error2?.last_name}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="tel" onChange={handleFormData("phone")} defaultValue={values.phone} placeholder="Main Phone Number" />
                            <span className="err">{error2?.phone}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Control type="text" name="address" onChange={handleFormData("address")} defaultValue={values.address} placeholder="Address*" />
                            <span className="err">{error2?.address}</span>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className="mb-3">
                            <Form.Select name="timezone" onChange={handleFormData("timezone")} defaultValue={values.timezone}>
                              <option disabled value=''>Select Time Zone*</option>
                              <option value="EST">EST</option>
                              <option value="CST">CST</option>
                              <option value="PST">PST</option>
                            </Form.Select>
                            <span className="err">{error2?.timezone}</span>
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Control type="password" name="password" onChange={handleFormData("password")} placeholder="Enter your new password*" />
                            <span className="err">{error2?.password}</span>
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Control type="password" name="confirmpassword" onChange={handleFormData("confirmpassword")} placeholder="Confirm your password*" />
                            <span className="err">{error2?.confirmpassword}</span>
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <Form.Group className="mb-3">
                            <Form.Select name="facilitator_selection" value={values.facilitator_selection} onChange={handleFormData("facilitator_selection")}>
                              <option value="">Facilitator?*</option>
                              <option value="self_facilitate">I will be the facilitator</option>
                              <option value="nominated">I am nominating a facilitator</option>
                              <option value="requested_facilitation">I want Dasya to provide me with a facilitator</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                        {values.facilitator_selection === 'nominated' && (
                          <Col md={12}>
                            <Form.Group className="mb-3">
                              <Form.Control type="email" name="facilitator_email" onChange={handleFormData("facilitator_email")} value={values.facilitator_email} placeholder="Enter Facilitator Email*" />
                              <span className="err">{error2?.facilitator_email}</span>
                            </Form.Group>
                          </Col>
                        )}
                        <Col md={12}>
                          <Form.Group className="iagree mb-3">
                            <Form.Check className="text-grey" type="checkbox" label="Make name visible to tutors" name="name_visible" onChange={handleOnChange} checked={values.name_visible} />
                          </Form.Group>
                          <Form.Group className="iagree mb-3">
                            <Form.Check className="text-grey" type="checkbox" label="Make contact number visible to tutors" name="number_visible" onChange={handleOnChange} checked={values.number_visible} />
                          </Form.Group>
                          <Form.Group className="iagree mb-3">
                            <Form.Check className="text-grey" type="checkbox" label="Allow live tutoring session" name="allow_live_session" onChange={handleOnChange} checked={values.allow_live_session} />
                          </Form.Group>
                        </Col>
                        <Col md={12}>
                          <h6 className="text-muted">GIVE PARENTAL CONSENT</h6>
                          <p className="text-muted">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                          </p>
                          <Form.Group className="iagree mb-3">
                            <Form.Check className="text-grey" type="checkbox" name="parental_consent" checked={values.parental_consent} onChange={handleOnChange} label={`I hereby consent to the above information that is shared on Dasya as on ${formatDate()}`} />
                            <span className="err">{error2?.parental_consent}</span>
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                    <div className="signup-back-btn">
                      <Link onClick={prevStep} className="btn btn-link">Back</Link>
                      <ActionButton
                        type='submit'
                        className='btn btn-primary btn-pill px-4'
                        title='Give Parental Consent'
                        requiredFields={[
                          values?.facilitator_selection,
                          values?.first_name,
                          values?.last_name,
                          values?.phone,
                          values?.address,
                          values?.password,
                          values?.confirmpassword,
                          values?.parental_consent ? values?.parental_consent : ''
                        ]}
                      />
                    </div>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
}

export default ParSignupStepThree;